import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { useTranslation } from 'react-i18next';
import { dataActionCreators, Project } from '../../store/Data';
import { UserLoginState } from '../../store/Login';
import { useMsal } from '@azure/msal-react';
import { TeamsState } from '../../store/TeamsState';
import { ContactsActionCreators } from '../../store/contacts';
import { Button, Skeleton, SkeletonItem, Text } from '@fluentui/react-components';
import { Dismiss24Filled, Edit24Filled, PeopleTeam24Filled } from "@fluentui/react-icons";
import { useQuickViewStyles } from '../Styles/QuickView';
import { useContacts } from '../Tools/ObjectLoader';

export const ProjectQuickView = () => {
    const projectQuickView = useSelector<ApplicationState, Project | null>((state: ApplicationState) => state.data.projectQuickView);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { instance } = useMsal();
    const teamsState = useSelector<ApplicationState, TeamsState>((state: ApplicationState) => state.teamsState);
    const viewDebugInfo = useSelector((state: ApplicationState) => state.userNeomyticLogin.viewDebugInfo);
    const { contacts } = useContacts();
    const UserLoginState = useSelector<ApplicationState, UserLoginState>((state: ApplicationState) => state.userNeomyticLogin);
    const styles = useQuickViewStyles();

    // Load project contact if not already done
    React.useEffect(() => {
        if (projectQuickView && projectQuickView.projectid && (projectQuickView.contacts === null || projectQuickView.contacts === undefined)) {
            dispatch(dataActionCreators.requestProjectContacts(instance, teamsState, projectQuickView.projectid));
        }
    }, [instance, teamsState, projectQuickView]);

    if (projectQuickView) {
        const custList: JSX.Element[] = [];
        contacts && projectQuickView.contacts && projectQuickView.contacts.map((c) => {
            const con = contacts.find(x => x.contactid === c.contactid);
            if (con) {
                custList.push(<div className={styles.titleAndOps}>
                    <Button appearance="transparent" style={{ padding: "0", border: "0", justifyContent: "start" }} onClick={() => dispatch(ContactsActionCreators.requestContactQuickView(con))} >{con.firstName + " " + con.lastName}</Button>
                    <Text truncate>{c.relationShipTypeId ? t(c.relationShipTypeId) : "?"}</Text>
                </div>);
            }

        });

        return (
            <div className={styles.root} >
                <div className={styles.titleAndOps}>
                    <h2>{"Project : " + (projectQuickView.displayName ? projectQuickView.displayName : "?")}</h2>
                    <div className={styles.titleAndOpsButtons}>
                        {UserLoginState && UserLoginState.rigths && UserLoginState.rigths.isAdmin && <Button icon={<Edit24Filled />} shape="circular" title={t('Edit')} onClick={() => dispatch(dataActionCreators.requestProjectEdition(projectQuickView))} />}
                        <Button icon={<Dismiss24Filled />} shape="circular" title="Close" onClick={() => dispatch(dataActionCreators.requestClearQuickView())} />
                    </div>
                </div>
                {viewDebugInfo &&
                    <>
                        <h2>Id</h2>
                        <Text truncate>{projectQuickView.projectid}</Text>
                    </>
                }
                <h2>{t('Start')}</h2>
                <Text truncate>{projectQuickView.dateDebut ? new Date(projectQuickView.dateDebut).toLocaleDateString() : t('NotDefined')}</Text>
                <h2>{t('End')}</h2>
                <Text truncate>{projectQuickView.dateFin ? new Date(projectQuickView.dateFin).toLocaleDateString() : t('NotDefined')}</Text>
                {projectQuickView.description && <>
                    <h2>Description</h2>
                    <pre style={{ whiteSpace: "pre-wrap" }}>{projectQuickView.description}</pre>
                </>}
                {UserLoginState && UserLoginState.rigths && UserLoginState.rigths.isAdmin &&
                    <>
                        <div className={styles.titleAndOps}>
                            <h2>Contacts</h2>
                            <Button icon={<PeopleTeam24Filled />} shape="circular" title={t('People')} onClick={() => dispatch(dataActionCreators.requestProjectContactsEdition(projectQuickView))} />
                        </div>

                        {projectQuickView.contacts !== null
                            ? (custList.length > 0
                                ? custList.map(i => i)
                                : <Text>{t('NotDefined')}</Text>)
                            : <Skeleton>
                                <SkeletonItem />
                            </Skeleton>
                        }
                    </>
                }
            </div>
        );
    }
    return null;
};